import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../apollo-client';
import {appHistory} from '../../history';
import {store} from '../../store';

import {SettingsSidebar} from './settings-sidebar';

const SETTINGS_SIDEBAR_REACT_MOUNT_ID = 'settings-sidebar-react-mount';

export const mountSettingsSidebar = (glossaryKey?: string | null) => {
    const settingsSidebarContainer = document.getElementById(SETTINGS_SIDEBAR_REACT_MOUNT_ID);

    if (settingsSidebarContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <SettingsSidebar glossaryKey={glossaryKey} />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            settingsSidebarContainer
        );
    }
};
